export default __webpack_public_path__ + "static/media/ssl-commerce.18588cb5.png";